import axios from "axios";
import { getCookie } from "@/utils/cookie";
import { Notification } from "element-ui";
import router from "@/router/index";
import store from "@/store/index";

const Request = axios.create({
  baseURL: process.env.NODE_ENV == "development" ? "/pack" : "/prod-api",
});

Request.interceptors.request.use(
  (config) => {
    const isToken = (config.headers || {}).isToken === false
    /*if (process.env.NODE_ENV == "development") {
      config.headers["Authorization"] = getCookie("Authorization");
      return config;
    }*/
    if (!isToken) {
      console.log("isToken",isToken);
      if (getCookie("Authorization")) {
        config.headers["Authorization"] = getCookie("Authorization");
      } else {
        // router.push("/login").catch((err) => {});
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Request.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.headers['content-type'] === 'application/octet-stream' || response.headers['content-type'] === 'application/octet-stream;charset=utf-8') {
      return response.data;
    }
    if (response.headers['content-type'] === 'application/vnd.ms-excel;charset=utf-8') {
      return response.data;
    }
    if (response.config.url.includes("/fourAlogin")) {
      return response.data;
    } else {
      if (response.data.code == "200") {
        return response.data;
      } else {
        if (response.config.hideError) {
          return response.data;
        } else if (response.data.code == "401") {
          Notification({
            type: "error",
            message: response.data.msg || JSON.stringify(response.data),
          });
          store.commit("moduleLogin/resetUser", {});
          // router.push("/login").catch((err) => {});
          return Promise.reject(response.data);
        } else if (response.data.code == "500") {
          Notification({
            type: "error",
            message: response.data.msg || "访问失败",
          });
        } else {
          Notification({
            type: "error",
            // message: response.data.msg || JSON.stringify(response.data),
            message: "访问失败，请联系俱乐部人员",
          });
          return Promise.reject(response.data);
        }
      }
    }
  },
  function (error) {
    if (error.response.status == "403" || error.response.status == "401") {
      Notification({
        type: "error",
        message:
          error.response.data.message || JSON.stringify(error.response.data),
      });
      store.commit("moduleLogin/resetUser", {});
      // router.push("/login").catch((err) => {});
    } else if  (error.response.status == "400"){
      Notification({
        type: "error",
        message: "访问失败",
      });
    } else {
      Notification({
        type: "error",
        message: error.response.data.msg || JSON.stringify(error.response.data),
      });
      return Promise.reject(error);
    }
  }
);

function GetRequest(url, params, config = {}) {
  return Request.get(url, { params, ...config });
}

function GetRequestBlob(url, params, config = {}) {
  return Request.get(url, { params, ...config, responseType: "blob" });
}

function PostRequestBlob(url, params, config = {}) {
  const headers = {};
  headers["Content-Type"] = "application/json; charset=UTF-8";
  const param = JSON.stringify(params);
  return Request.post(url,param, { headers, responseType: "blob" });
}

function PostRequest(url, params, config = {}) {
  return new Promise((resolve) => {
    config.headers["Content-Type"] = "application/json; charset=UTF-8";
    const param = JSON.stringify(params);
    resolve (Request.post(url, param, { ...config }))
  }).catch(() => {})
}

function LogPostRequest(url, params) {
  const headers = {};
  headers["Content-Type"] = "application/json; charset=UTF-8";
  const param = JSON.stringify(params);
  return Request.post(url, param, { headers, timeout: 70000 });
}

function PostTextRequest(url, params) {
  const headers = {};
  headers["Content-Type"] = "text/plain";
  const param = JSON.stringify(params);
  return Request.post(url, param, { headers });
}
function UploadRequest(url, params) {
  const headers = {};
  headers["Content-Type"] = "multipart/form-data";
  return Request.post(url, params, { headers });
}

function PutRequest(url, params) {
  const headers = {};
  headers["Content-Type"] = "application/json; charset=UTF-8";
  const param = JSON.stringify(params);
  return Request.put(url, param, { headers });
}

function DeleteRequest(url, params) {
  return Request.delete(url, params);
}

export {
  GetRequest,
  PostRequest,
  UploadRequest,
  PutRequest,
  DeleteRequest,
  GetRequestBlob,
  PostTextRequest,
  LogPostRequest,
  PostRequestBlob
};
